module.exports = new __parcel__URL__("shockwave.2ac120ef.png").toString();